import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import FormUnit from "./formUnit";

import "./form.css";
import "../button/button.css";
import { AuthContext } from "../../App";
import { useEffect, useState, useContext } from "react";

const FormFrame = (props) => {
  return (
    <div>
      {props.title && (
        <div className="text-center mt-5">
          <h2>{props.title}</h2>
        </div>
      )}

      <Form className="p-1" >
        {props.formData.map((data, index) => {
          return (
            <div className="w-75 w-sm-50 mx-auto header-form" key={index}>
              <FormUnit
                title={data.title}
                name={data.name}
                placeholder={data.placeholder}
                required={data.required}
                disabled={data.disabled}
                value={data.value}
                index={index}
                handleChange={props.handleChange}
              />
            </div>
          );
        })}
        {props.children}
      </Form>
    </div>
  );
};

export default FormFrame;